import React from 'react'
import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Button,
  Flex,
  FormControl,
  FormHelperText,
  FormLabel,
  Grid,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  Textarea,
  useClipboard,
} from '@chakra-ui/react'
import { Link } from 'react-router-dom'

import { BRAND } from '../../../components/ui'

const SITE = 'https://www.klazia.com'

// La ficha depende del programa que se matricule.
const FICHAS = [
  { value: '', label: 'Todavía no (aún no está matriculado)' },
  { value: 'ficha-matricula', label: 'Ficha anual · Primaria y bachillerato' },
  { value: 'ficha-semestralizado', label: 'Ficha semestralizada' },
  { value: 'ficha-tecnicas', label: 'Ficha de carreras técnicas' },
]

const buildMessage = ({ firstName, email, password, ficha }) =>
  [
    `Hola ${firstName}, ya creamos tu cuenta en Klazia.`,
    '',
    `Ingresa en ${SITE}/login`,
    `Usuario: ${email}`,
    `Contraseña: ${password}`,
    ficha ? '' : null,
    ficha ? `Cuando ingreses, llena tu ficha de matrícula aquí: ${SITE}/${ficha}` : null,
  ]
    .filter((line) => line !== null)
    .join('\n')

function CopyRow({ label, value }) {
  const { onCopy, hasCopied } = useClipboard(value || '')
  return (
    <Box>
      <Text fontSize="xs" color="gray.500" mb={1}>
        {label}
      </Text>
      <Flex align="center" justify="space-between" gap={2} bg="gray.50" border="1px solid" borderColor="gray.200" borderRadius="md" px={3} py={2}>
        <Text fontFamily="mono" fontSize="sm" wordBreak="break-all" userSelect="all">
          {value}
        </Text>
        <Button size="xs" variant="ghost" colorScheme="purple" onClick={onCopy} flexShrink={0}>
          {hasCopied ? 'Copiado' : 'Copiar'}
        </Button>
      </Flex>
    </Box>
  )
}

export default function CredentialsModal({ result, onClose }) {
  const [ficha, setFicha] = React.useState('')

  const firstName = (result?.student?.name || '').split(' ')[0] || ''
  const message = result
    ? buildMessage({ firstName, email: result.credentials.email, password: result.credentials.password, ficha })
    : ''
  const { onCopy, hasCopied } = useClipboard(message)

  return (
    <Modal isOpen={Boolean(result)} onClose={onClose} size="lg" closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize="lg">Acceso para compartir</ModalHeader>
        <ModalCloseButton />
        {result && (
          <ModalBody>
            <Text fontSize="sm" color="gray.600" mb={4}>
              Se creó la cuenta de <b>{result.student.name}</b> (código {result.student.id}).
            </Text>

            <Alert status="warning" borderRadius="md" mb={4} fontSize="sm">
              <AlertIcon />
              <AlertDescription>
                La contraseña se muestra solo esta vez. Si se pierde, asigna una nueva en «Actualizar datos» del
                estudiante.
              </AlertDescription>
            </Alert>

            <Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} gap={3} mb={4}>
              <CopyRow label="Usuario" value={result.credentials.email} />
              <CopyRow label="Contraseña temporal" value={result.credentials.password} />
            </Grid>

            <FormControl mb={3}>
              <FormLabel fontSize="sm">Incluir enlace de la ficha de matrícula</FormLabel>
              <Select id="credentials-ficha" size="sm" value={ficha} onChange={(e) => setFicha(e.target.value)}>
                {FICHAS.map((el) => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </Select>
              <FormHelperText fontSize="xs">
                La ficha solo se puede enviar cuando el programa ya está matriculado.
              </FormHelperText>
            </FormControl>

            <FormControl>
              <FormLabel fontSize="sm">Mensaje para WhatsApp</FormLabel>
              <Textarea id="credentials-message" value={message} readOnly rows={8} fontSize="sm" bg="gray.50" />
            </FormControl>
          </ModalBody>
        )}
        <ModalFooter gap={3} flexWrap="wrap">
          {result && (
            <Button as={Link} to={`/plataforma/asesoras/ver-estudiante/${result.student.id}`} variant="outline">
              Ir al estudiante para matricular
            </Button>
          )}
          <Button bg={BRAND} color="white" _hover={{ bg: '#463fd1' }} onClick={onCopy}>
            {hasCopied ? 'Mensaje copiado' : 'Copiar mensaje'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
